module.exports = __webpack_public_path__ + "static/assets/763ab282aafc9447a493f5e73bb1b9b8.gif";